import React, { useState } from 'react';
import Dashboard from './Dashboard';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom'
import Login from './Login';
import NotFound from './NotFound';

function App() {

    const [email, setEmail] = useState(localStorage.getItem('email'));


    const setEmailWrapper = (emailValue) => {
        localStorage.setItem('email', emailValue);
        setEmail(emailValue);
    }

    const cleanup = () => {
        localStorage.clear();
        setEmail("");
    }

    return (
        <>
            <Router>
                <Routes>
                    <Route exact path='/' element={<Login email={email} setEmail={setEmailWrapper} />} />
                    <Route exact path='/dashboard' element={<Dashboard email={email} cleanup={cleanup} />} />
                    <Route exact path='/not-found' element={<NotFound cleanup={cleanup} />} />
                    <Route path="*"
                        element={<Navigate to="/" replace />} />
                </Routes>
            </Router>
        </>
    )
}

export default App